@if (showInstallBanner$ | async) {
  <div class="install-banner">
    <div class="install-content">
      <mat-icon>get_app</mat-icon>      <div class="install-text">
        <h4>{{ 'PWA.INSTALL_TITLE' | translate }}</h4>
        <p>{{ 'PWA.INSTALL_MESSAGE' | translate }}</p>
      </div>
    </div>    <div class="install-actions">
      <button mat-button (click)="dismissBanner()">
        {{ 'PWA.INSTALL_DISMISS' | translate }}
      </button>
      <button mat-raised-button color="primary" (click)="installApp()">
        {{ 'PWA.INSTALL_NOW' | translate }}
      </button>
    </div>
  </div>
}
